import React from 'react';
import PropTypes from 'prop-types';
import Control from 'react-leaflet-control';

function LogoControl(props) {
  const { position, mapType } = props;
  if (mapType !== 'mapy') {
    return null;
  }
  return (
    <Control position={position}>
      <div>
        <a href="http://mapy.cz/" target="_blank">
          <img src="https://api.mapy.cz/img/api/logo.svg" alt="Mapy logo" />
        </a>
      </div>
    </Control>
  );
}

LogoControl.propTypes = {
  position: PropTypes.string,
  mapType: PropTypes.string,
};

export default LogoControl;
